import { useContext } from 'react';
import { DialogStore } from '../stores/DialogStore';
import { SystemContext } from '../System';

export function useDialogStore(): DialogStore {
  const system = useContext(SystemContext);
  return system.dialogStore;
}
